<script>
	import { onMount } from 'svelte';
	import SharedUserIconAndName from './SharedUserIconAndName.svelte';

	export let position = 1;
	//get only sorted list
	//first user is the user himself
	export let users = [];
	export let userId = '5';
	//document.fonts.load
	let children;
	let sharedUserWrapperBind;
	let showCollapsed = false;
	let isSorted = false;
	let maxHeight = '72px';
	let truncate = true;
	$: {
		const currentUser = users.find((el) => el.id == userId);
		users = users.sort(function (a, b) {
			return a.name.localeCompare(b.name);
		});
		if (currentUser) {
			users = [currentUser, ...users.filter((el) => el.id != userId)];
		}
		if (sharedUserWrapperBind) {
			let num = 0;
			children = sharedUserWrapperBind.childNodes;
			children = [...children].filter(
				(el) => el && el.classList && ![...el.classList].includes('showCollapsed')
			);
			for (let i = 1; i < children.length; i++) {
				if (
					children[i]?.getBoundingClientRect().top !== children[i - 1]?.getBoundingClientRect().top
				) {
					num++;
					if (num == 2) {
						stopAt = i - 1;
						if (i !== children.length) {
							showCollapsed = true;
						}
						break;
					}
				}
			}
		}
		isSorted = true;
	}

	onMount(() => {
		document.fonts.ready.then(function () {
			users = users;
		});
	});
	let backgroundColor = [
		'rgba(250, 209, 85, 1)',
		'rgba(196, 196, 196, 1)',
		'rgba(228, 194, 162, 1)',
		'rgba(244, 244, 244, 1)'
	];
	let stopAt = users.length;
</script>

{#if users.length > 0 && isSorted}
	<div
		bind:this={sharedUserWrapperBind}
		class="sharedUserWrapper"
		style={`background-color:${backgroundColor[Math.min(3, position - 1)]};max-height:${maxHeight}`}
	>
		{#each users.slice(0, stopAt + 1) as user, i}
			{#if i === users.slice(0, stopAt + 1).length - 1}
				<div class="userElement" style="margin-right:25px">
					<SharedUserIconAndName
						size="19"
						userName={user.name}
						highlight={userId == user.id}
						src={user.src}
						{truncate}
					/>
				</div>
			{:else}
				<div class="userElement">
					<SharedUserIconAndName
						size="19"
						userName={user.name}
						highlight={userId == user.id}
						src={user.src}
						{truncate}
					/>
				</div>
			{/if}
		{/each}
		{#if showCollapsed === true}
			<div
				class="showCollapsed"
				on:click={() => {
					maxHeight = 'auto';
					stopAt = users.length;
					truncate = false;
					showCollapsed = false;
				}}
			>
				+{users.length - stopAt - 1}
			</div>
		{/if}
	</div>
{/if}

<style>
	.sharedUserWrapper {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		border-radius: 6px;
		padding: 6px 10px;
		font-family: 'Work Sans';
		overflow: hidden;
		row-gap: 8px;
		/* font: initial; */
	}
	.userElement {
		margin-right: 8px;
		height: 26px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: inherit;
		/* border: 0.5px solid black; */
	}
	.sharedUserWrapper:last-child {
		margin-right: 25px;
	}
	.showCollapsed {
		position: absolute;
		bottom: 6px;
		right: 5px;
		height: 26px;
		width: 26px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: white;
		border-radius: 50%;
		font-size: 11px;
		color: rgba(51, 51, 51, 1);
		font-family: 'Work Sans';
		font-weight: 600;
		cursor: pointer;
	}
</style>
